export default __webpack_public_path__ + "static/media/inex2.43ab1065.svg";